const LOCAL_PUBLIC_WEB_ORIGIN = "http://127.0.0.1:4321";
const CADDY_PUBLIC_WEB_ORIGIN = "https://public.socialcoach.localhost";
const PRODUCTION_APP_HOSTNAME = "app.socialcoach.io";
const PRODUCTION_PUBLIC_LINK_ORIGIN = "https://myoc.io";

// Caddy terminates TLS on :443. Astro is HTTP-only on :4321 and binds IPv4;
// Safari resolves localhost to ::1 first and the iframe fails to connect.
export const publicWebOrigin = (): string => {
  const { hostname } = window.location;
  if (hostname === "socialcoach.localhost") {
    return CADDY_PUBLIC_WEB_ORIGIN;
  }
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return LOCAL_PUBLIC_WEB_ORIGIN;
  }
  return window.location.origin;
};

export const publicLinkOrigin = (): string =>
  window.location.hostname === PRODUCTION_APP_HOSTNAME ? PRODUCTION_PUBLIC_LINK_ORIGIN : publicWebOrigin();
